/* @flow */

import React from "react";
import { SuccessView } from "@crossroads/shop-views";
import { useAnalytics } from "context/analytics";
import { useClient } from "entrypoint/shared";
import { OrderData } from "state/data";
import { useData } from "crustate/react";
import { load as loadOrder } from "state/order";
import { subscribeToNewsletter } from "queries";
import useFormat from "helpers/hooks/use-format";
import CheckIcon from "icons/checkmark-success.svg";
import { useTranslate } from "@awardit/react-use-translate";

const Success = (): React$Node => {
  const orderData = useData(OrderData);
  const { formatPrice } = useFormat();
  const analytics = useAnalytics();
  const t = useTranslate();

  return (
    <SuccessView
      hasRegretPurchaseButton
      orderData={orderData}
      useClient={useClient}
      analytics={analytics}
      formatPrice={formatPrice}
      additionalField="PHONE"
      loadOrder={loadOrder}
      subscribeToNewsletter={subscribeToNewsletter}
      CheckIcon={<CheckIcon aria-label={t("ICONS.CHECK")} style={{ color: "#3f921b" }} />}
    />
  );
};

export default Success;
